module.exports = __webpack_public_path__ + "img/clouding_overlay.679d0646.jpeg";